module.exports = __webpack_public_path__ + "img/icon_warn.e96fe6cf.svg";